import React from 'react';
import propTypes from 'prop-types';
import { Routes, Route } from 'react-router-dom';
import { ConsentsListPage } from './ConsentsListPage';

export function ConsentsPage({ location, isExpanded }) {
  return (
    <Routes location={location}>
      <Route
        path="/"
        element={<ConsentsListPage isExpanded={isExpanded} />}
      />
    </Routes>
  );
}

ConsentsPage.propTypes = {
  location: propTypes.object.isRequired,
  isExpanded: propTypes.bool.isRequired,
};
